import { TinyPopover, Toolbar } from '@octopus-do/octopus-storybook'
import { Globe, Pen } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { forwardRef } from 'react'

import { isValidUrl } from '@/helpers'

// Key the popover reports to Toolbar.Root; the submitted url follows it.
export const EDIT_LINK_POPOVER_ID = 'edit_link'

interface ContentProps {
  url: string
}

const Content: React.FC<ContentProps> = ({ url }) => (
  <TinyPopover.LinkInput
    icon={Globe}
    placeholder="Paste URL..."
    validate={isValidUrl}
    value={url}
  />
)

const Trigger = forwardRef<HTMLButtonElement>((_, ref) => {
  const { active, toggle } = TinyPopover.useTrigger()

  return (
    <Toolbar.DropdownButton
      active={active}
      icon={Pen}
      onClick={toggle}
      ref={ref}
      tooltip="Edit link"
    />
  )
})

interface Props {
  url: string
}

export const EditLinkPopover: React.FC<Props> = ({ url }) => {
  const { onClick } = Toolbar.useToolbarClick(EDIT_LINK_POPOVER_ID)

  const onSubmit = (value: string) => onClick([value])

  return (
    <TinyPopover.Root content={Content} onSubmit={onSubmit} url={url}>
      <Trigger />
    </TinyPopover.Root>
  )
}
